import clsx from 'clsx'
import { FC } from 'react'
import { ClassName } from 'types/props'

import classes from './index.module.scss'

export const Legend: FC<ClassName> = ({ children, className }) => (
  <legend className={clsx(classes.root, className)}>{children}</legend>
)
